"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.msgSetWithdrawAddress = void 0;
var ow_1 = __importDefault(require("ow"));
var address_1 = require("../../../utils/address");
var ow_types_1 = require("../ow.types");
var typeurl_1 = require("../../common/constants/typeurl");
exports.msgSetWithdrawAddress = function (config) {
    return (function () {
        function MsgSetWithdrawAddress(options) {
            ow_1.default(options, 'setWithdrawOptions', ow_types_1.owMsgSetWithdrawAddressOptions);
            this.delegatorAddress = options.delegatorAddress;
            this.withdrawAddress = options.withdrawAddress;
            this.validateAddresses();
        }
        MsgSetWithdrawAddress.prototype.toRawAminoMsg = function () {
            return {
                type: 'cosmos-sdk/MsgSetWithdrawAddress',
                value: {
                    delegator_address: this.delegatorAddress,
                    withdraw_address: this.withdrawAddress,
                },
            };
        };
        MsgSetWithdrawAddress.prototype.toRawMsg = function () {
            return {
                typeUrl: typeurl_1.COSMOS_MSG_TYPEURL.distribution.MsgSetWithdrawAddress,
                value: {
                    delegatorAddress: this.delegatorAddress,
                    validatorAddress: this.withdrawAddress,
                },
            };
        };
        MsgSetWithdrawAddress.prototype.validateAddresses = function () {
            if (!address_1.validateAddress({
                address: this.delegatorAddress,
                network: config.network,
                type: address_1.AddressType.USER,
            })) {
                throw new TypeError('Provided `delegatorAddress` doesnt match network selected');
            }
            if (!address_1.validateAddress({
                address: this.withdrawAddress,
                network: config.network,
                type: address_1.AddressType.USER,
            })) {
                throw new TypeError('Provided `withdrawAddress` doesnt match network selected');
            }
        };
        return MsgSetWithdrawAddress;
    }());
};
//# sourceMappingURL=MsgSetWithdrawAddress.js.map